import './faq.css'
import React from 'react'
import { Accordion } from 'react-bootstrap'

function Faq() {
    return (
        <>
            <h3 className='dashboard-head-title'>FAQ</h3>
            <div className='faq-parent'>
                <div className='faqs'>
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="7">
                            <Accordion.Header> Lorem ipsum, dolor sit amet consectetur adipisicing</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis nemo, quaerat iste expedita voluptates autem eligendi rerum quam voluptatem saepe.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
                <div className='faq-sep'></div>
                <div className='faq-form'>
                    <p className='faq-form-title'>Get in Touch!</p>
                    <div className='load-input'>
                        <label>Full Name</label>
                        <input required type={'text'} placeholder="Enter Full Name" className='form-input_ input3' />
                    </div>
                    <div className='load-input'>
                        <label>Email</label>
                        <input required type={'email'} placeholder="Enter Email" className='form-input_ input3' />
                    </div>
                    <div className='load-input'>
                        <label>Number</label>
                        <input required type={'text'} placeholder="Enter Number" className='form-input_ input3' />
                    </div>
                    <div className='load-input'>
                        <label>Message</label>
                        <textarea required spellCheck={true} type={'text'} placeholder="Write your message..." className='form-input_ input3' />
                    </div>
                    <div>
                        <button className='button-primary'>Contact Us</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Faq